import React from 'react';
import { Prospect } from '../../shared/types';
import { Card } from '../../components/ui/Card';
import { Search, MapPin, BookOpen, Smartphone, Star, CheckCircle2, TrendingUp } from 'lucide-react';

interface GoogleChannelSectionProps {
  prospect: Prospect;
}

export const GoogleChannelSection: React.FC<GoogleChannelSectionProps> = ({ prospect }) => {
  return (
    <section className="py-20 border-b border-slate-100 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-xs font-bold uppercase tracking-widest text-[var(--ym-prospect-primary)]">
             Valor de Longo Prazo & Estratégia de Domínio Digital
          </span>
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mt-3 leading-tight font-heading">
             Como a {prospect.trade_name} Alcançará o Rank #1 no Google
          </h2>
          <p className="text-slate-600 mt-4 text-sm md:text-base font-light leading-relaxed">
             Não entregamos apenas uma página bonita. Criamos um **Ativo Digital Permanente** focado em aquisição orgânica passiva, SEO semântico e fidelização por aplicativo exclusivo.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {/* SEO Rank #1 */}
          <Card className="border-slate-200 bg-white p-8 rounded-2xl flex flex-col justify-between shadow-[0_4px_24px_rgba(0,0,0,0.02)]">
            <div>
               <div className="p-3 rounded-xl bg-teal-50 text-teal-600 w-fit mb-6">
                 <Search className="w-6 h-6" />
               </div>
               <h3 className="text-xl font-bold text-slate-900 mb-3">Domínio no Rank #1 (Google)</h3>
               <p className="text-xs text-slate-600 leading-relaxed mb-6 font-light">
                 Arquitetura técnica otimizada para Core Web Vitals (nota 98+ no PageSpeed). Schema.org específico injetado para forçar o Google a destacar a marca no topo das buscas regionais em {prospect.city}.
               </p>
            </div>
            <div className="pt-4 border-t border-slate-100 text-xs text-teal-600 font-bold flex items-center gap-2">
               <TrendingUp className="w-4 h-4" /> Tráfego Orgânico Sem Pagar Anúncios
            </div>
          </Card>

          {/* Blog de Autoridade */}
          <Card className="border-slate-200 bg-white p-8 rounded-2xl flex flex-col justify-between shadow-[0_4px_24px_rgba(0,0,0,0.02)]">
            <div>
               <div className="p-3 rounded-xl bg-indigo-50 text-indigo-600 w-fit mb-6">
                 <BookOpen className="w-6 h-6" />
               </div>
               <h3 className="text-xl font-bold text-slate-900 mb-3">Blog de Autoridade Integrado</h3>
               <p className="text-xs text-slate-600 leading-relaxed mb-6 font-light">
                 Módulo de publicação para atrair clientes em momentos de dúvida. Cada artigo publicado vira uma porta de entrada permanente para pesquisas no Google por anos.
               </p>
            </div>
            <div className="pt-4 border-t border-slate-100 text-xs text-indigo-600 font-bold flex items-center gap-2">
               <CheckCircle2 className="w-4 h-4" /> Aquisição Passiva de Leads
            </div>
          </Card>

          {/* App Próprio como Ativo */}
          <Card className="border-slate-200 bg-white p-8 rounded-2xl flex flex-col justify-between shadow-[0_4px_24px_rgba(0,0,0,0.02)]">
            <div>
               <div className="p-3 rounded-xl bg-amber-50 text-amber-600 w-fit mb-6">
                 <Smartphone className="w-6 h-6" />
               </div>
               <h3 className="text-xl font-bold text-slate-900 mb-3">App Próprio (Ativo da Marca)</h3>
               <p className="text-xs text-slate-600 leading-relaxed mb-6 font-light">
                 Um aplicativo web instalado diretamente no celular do cliente sem passar pelas taxas das lojas de apps. Reduz custos de atendimento e bloqueia a concorrência.
               </p>
            </div>
            <div className="pt-4 border-t border-slate-100 text-xs text-amber-600 font-bold flex items-center gap-2">
               <Star className="w-4 h-4 fill-amber-500" /> Retenção & LTV Maximizado
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};
